import { STORAGE_KEYS } from '@/config/constants'

export default function authHeader() {
  let user = null
  try {
    user = JSON.parse(localStorage.getItem(STORAGE_KEYS.USER))
  } catch (e) {
    localStorage.removeItem(STORAGE_KEYS.USER)
  }

  // Токен хранится как user.access (SimplJWT), а не user.accessToken
  if (user && user.access) {
    return { Authorization: 'Bearer ' + user.access }
  }
  return {}
}
